import { render, staticRenderFns } from "./PpinList.vue?vue&type=template&id=fbfce360&scoped=true&"
import script from "./PpinList.vue?vue&type=script&lang=js&"
export * from "./PpinList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfce360",
  null
  
)

export default component.exports